import { Grid } from "@mui/material";
import ModalContainer from "components/common/modals/modalContainer/ModalContainer";
import React from "react";
import CiedDeviceInformationPreviewItem from "../preview/CiedDeviceInformationPreviewItem";

const DuplicatePatientDevicesModal = ({
  devices,
  show,
  title,
  onClose,
  onSelected,
  selectedDevice,
  isSubmitting,
}) => {
  return (
    <ModalContainer show={show} title={title} maxWidth="xl" onClose={onClose}>
      <Grid container columnSpacing={3}>
        {devices?.map((previousDevice, index) => (
          <CiedDeviceInformationPreviewItem
            key={index}
            deviceInformation={{
              ...previousDevice,
              modelName:
                previousDevice?.model_display_name ||
                previousDevice?.device_model,
              modelNumber: previousDevice?.device_serial,
            }}
            isPreviousDevices={true}
            isCombinedDevices={true}
            onSelected={onSelected}
            selectedDevice={selectedDevice}
            isSubmitting={isSubmitting}
            hasPreviousDevice={
              devices?.filter((device) => device?.device_type === "Previous")
                ?.length > 0
            }
          />
        ))}
      </Grid>
    </ModalContainer>
  );
};

export default DuplicatePatientDevicesModal;
